// ============================================================
// サイト基本情報（後から編集できるように一元管理）
// ============================================================

export const site = {
  companyName: "株式会社MEGURI",
  companyNameReading: "株式会社 目くり",
  business: "ジビエ食肉加工",
  address: "長崎県佐世保市日宇町1094-1",
  phone: "090-2853-0535",
  email: "hina.20110615@gmail.com",
  holiday: "不定休",
  serviceArea: "佐世保市から全国",
  // 公式LINE / Instagram URL
  lineUrl: "https://lin.ee/WGyHu8X",
  instagramUrl: "https://www.instagram.com/satokop3105/",
  // 銀行口座情報
  bankName: "GMOあおぞらネット銀行",
  bankBranch: "法人営業部",
  bankAccountType: "普通",
  bankAccountNumber: "2111100",
  bankAccountHolder: "カ）メグリ",
};